import { FiStar } from 'react-icons/fi';
import './Testimonials.css';

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Sarah Mitchell',
      business: 'Mitchell Farm Supplies',
      location: 'Rockhampton, QLD',
      text: 'Working with Mediawise transformed how we think about our business. The Wise Check pinpointed exactly where we were losing opportunities, and their strategic guidance helped us increase revenue by 40% in six months.',
      rating: 5
    },
    {
      name: 'David Chen',
      business: 'Central QLD Plumbing',
      location: 'Mackay, QLD',
      text: 'I was drowning in day-to-day operations with no clear direction. Mitch helped us systemize our processes and implement a CRM that actually works. Now I have time to focus on growth instead of firefighting.',
      rating: 5
    },
    {
      name: 'Emma Thompson',
      business: 'Capricorn Coast Cafe',
      location: 'Yeppoon, QLD',
      text: 'The marketing strategies were game-changing for our cafe. We went from unpredictable foot traffic to consistent bookings and a loyal customer base. Highly recommend their approach!',
      rating: 5
    }
  ];

  return (
    <section className="testimonials-section" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="text-center mb-12">
          <h2 className="section-title-light">What Our Clients Say</h2>
          <div className="gradient-line mx-auto"></div>
        </div>

        <div className="testimonials-grid" data-testid="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card" data-testid={`testimonial-${index}`}>
              <div className="testimonial-stars">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <FiStar key={i} className="star-icon" />
                ))}
              </div>
              <p className="testimonial-text">"{testimonial.text}"</p>
              <div className="testimonial-author">
                <div className="author-info">
                  <p className="author-name">{testimonial.name}</p>
                  <p className="author-business">{testimonial.business}</p>
                  <p className="author-location">{testimonial.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;